import React from 'react'
import CountUp from 'react-countup'
import "../assets/js/main";
import "../assets/css/style.css"


const Facts = () => {


  return (
    <section id="facts" class="facts">
    <div className="container">
        <div className="section-title">
            <h2>Facts</h2>
            <p>As a Node JS backend developer since last four years I worked with a number of clients and they are completely satisfied from my work. All the projects are pixel-perfect and responsive for leading buisnesess.</p>
        </div>
        <div className="flex" style={{display: "flex"}}>
            {/* <div className="col-lg-3 col-md-6 d-md-flex align-items-md-stretch" data-aos="fade-up"> */}
            <div class="good" data-aos="fade-up">
                <div className="count-box"> <i className="bi bi-emoji-smile"></i>
                 {/* <span data-purecounter-start="0"
                        data-purecounter-end="232" data-purecounter-duration="1" class="purecounter">


                        </span> */}
                        <CountUp start={0} end={54} duration={3}/>
                    <p><strong>Happy Clients</strong><br/> & fully satisfied</p>
                </div>
            </div>
            <div className="col-lg-3 col-md-6 d-md-flex align-items-md-stretch" data-aos="fade-up"
                data-aos-delay="100">
                <div class="count-box"> <i class="bi bi-journal-richtext"></i> 
                <CountUp start={0} end={31} duration={3}/>
                    <p><strong>Projects Completed</strong><br/>with 100% of clients satisfaction </p>
                </div>
            </div>
            {/* <div class="col-lg-3 col-md-6 d-md-flex align-items-md-stretch" data-aos="fade-up"
                data-aos-delay="200"> */}
                <div class="good" data-aos="fade-up">
                <div class="count-box"> <i class="bi bi-person-workspace"></i> 
                <CountUp start={0} end={2} duration={1}/>

                    <p><strong>Years of experience</strong><br/>working for last 2+ years</p>
                </div>
            </div>
            <div class="col-lg-3 col-md-6 d-md-flex align-items-md-stretch" data-aos="fade-up"
                data-aos-delay="300">
                <div class="count-box"> <i class="bi bi-github"></i>
                <CountUp start={0} end={23} duration={3}/>

                    <p><strong>Code Repositories</strong><br/>I've contributed to or created.</p>
                </div>
            </div>
        </div>
    </div>
</section>
  )
}

export default Facts